import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Card, Flex, Box, Text, Heading, AlertDialog, TextField, Separator } from '@radix-ui/themes';
import { Cross2Icon, PlusIcon } from '@radix-ui/react-icons';
import api from '../../api';
import { toast } from 'react-toastify';
import AddWard from '../../components/forms/guardians/AddWardForm';
import GenerateGuardianCode from '../../components/forms/guardians/GenerateGuardianCode';

const GuardianAddWard = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [generatedCode, setGeneratedCode] = useState(null);
  const students = useSelector((state) => state.guardian.students) || [];

  const handleCopyCode = async () => {
    navigator.clipboard.writeText(generatedCode)
    toast.info("Code copied", {
      position: "top-right"
    });
  }

  return (
    <>
      <AlertDialog.Root open={isOpen} onOpenChange={setIsOpen}>
        <AlertDialog.Trigger>
          <Button size="3" variant="solid">
            <PlusIcon />Add New Ward
          </Button>
        </AlertDialog.Trigger>

        <AlertDialog.Content>
          <AlertDialog.Title>Add New Ward</AlertDialog.Title>
          <Cross2Icon className="absolute top-2 right-2 cursor-pointer" onClick={() => setIsOpen(false)} />
          {generatedCode ? (
            <Flex direction="column" gap="2" align="center" p="4">
              <Text size="2" align="center">Your code has been generated. </Text>
              <Text size="2" align="center" mb="4">Share this code with your ward to add them to your account.</Text>
              <Text size="5" weight="bold" align="center" pv="4">{generatedCode}</Text>
              <Button size="3" variant="solid" onClick={handleCopyCode}>Copy Code</Button>
            </Flex>
          ) : (
            <Flex direction="row" gap="4" mb="4">
              <Text>If your ward is already registered, create a token to add them to your account.</Text>
              <GenerateGuardianCode onComplete={setGeneratedCode} />
            </Flex>
          )}
          <Separator size='4' mb="4" />
          <AddWard onComplete={() => setIsOpen(false)} />
        </AlertDialog.Content>
      </AlertDialog.Root>

    </>

  );
};

export default GuardianAddWard;


